import * as React from "react"
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import cx from "classnames"

import Container from "@components/elements/container"
import SideTitle from "@components/elements/sideTitle"
import Wysiwyg from "@components/elements/wysiwyg"
import Cta from "@components/elements/cta"

import styles from "./sideImageWide.module.scss"

const SideImageWide = ({
  sideTitle,
  title,
  titleLarge,
  text,
  cta,
  imageData,
  imageMobileData,
  imageAlign,
  imageAlt,
}) => {
  const images = withArtDirection(getImage(imageData), [
    {
      media: "(max-width: 1023px)",
      image: getImage(imageMobileData),
    },
  ])

  return (
    <section
      className={cx(styles.sideImageWide, {
        [styles[imageAlign]]: imageAlign,
      })}
    >
      <Container className={styles.container}>
        <div className={styles.content}>
          <SideTitle title={sideTitle} />
          <h2
            className={cx(styles.title, {
              [styles.isLarge]: titleLarge,
            })}
          >
            {title}
          </h2>
          <Wysiwyg className={styles.text} contentHtml={text} />

          <Cta {...cta} className={styles.buttonCta} />
        </div>

        <div className={styles.picture}>
          <GatsbyImage
            className={styles.pictureImage}
            image={images}
            alt={imageAlt}
          />

          <Cta {...cta} className={styles.pictureCta} color="light" />
        </div>
      </Container>
    </section>
  )
}

export default SideImageWide
